var ModalEffect;
(function (ModalEffect) {
    ModalEffect["SCALE_FADE"] = "scaleFade";
})(ModalEffect || (ModalEffect = {}));

export { ModalEffect };
//# sourceMappingURL=modal.mjs.map
